import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X, Leaf } from 'lucide-react';
import { navItems } from '../mock/mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const [openDrop, setOpenDrop] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpenMobile(false);
    setOpenDrop(null);
  }, [location.pathname]);

  const isActive = (to) => (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to));
  const solid = scrolled || location.pathname !== '/';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${solid ? 'bg-cream/95 backdrop-blur-md shadow-[0_2px_20px_rgba(27,67,50,0.08)] py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className={`flex items-center justify-center w-11 h-11 rounded-full transition-colors ${solid ? 'bg-forest' : 'bg-white/15 backdrop-blur-sm border border-white/30'}`}>
            <Leaf className={`w-6 h-6 ${solid ? 'text-gold-light' : 'text-white'}`} strokeWidth={1.6} />
          </span>
          <span className="leading-tight">
            <span className={`block font-display text-[15px] md:text-lg font-600 tracking-wide ${solid ? 'text-forest' : 'text-white'}`}>RODERICK GAY</span>
            <span className={`block font-display text-[11px] md:text-xs tracking-[0.28em] ${solid ? 'text-gold' : 'text-gold-light'}`}>BOTANICAL GARDEN</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden xl:flex items-center gap-6">
          {navItems.map((item) => (
            <div key={item.label} className="relative" onMouseEnter={() => setOpenDrop(item.label)} onMouseLeave={() => setOpenDrop(null)}>
              <Link to={item.to} className={`nav-link flex items-center gap-1 text-[14px] font-500 tracking-wide transition-colors ${solid ? 'text-ink hover:text-forest' : 'text-white/90 hover:text-white'} ${isActive(item.to) ? 'active' : ''}`}>
                {item.label}
                {item.children && <ChevronDown className="w-3.5 h-3.5" />}
              </Link>
              {item.children && openDrop === item.label && (
                <div className="absolute left-0 top-full pt-3 w-60">
                  <div className="bg-white rounded-xl shadow-xl border border-sand overflow-hidden py-2">
                    {item.children.map((c) => (
                      <Link key={c.label} to={c.to} className="block px-5 py-2.5 text-sm text-ink hover:bg-cream hover:text-forest transition-colors">{c.label}</Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
          <Link to="/give" className="ml-1 px-5 py-2.5 rounded-full bg-gold text-white text-sm font-600 tracking-wide hover:bg-gold-light transition-colors shadow-sm">Donate</Link>
        </nav>

        <button className="xl:hidden p-2" onClick={() => setOpenMobile(!openMobile)} aria-label="Menu">
          {openMobile ? <X className={solid ? 'text-forest' : 'text-white'} /> : <Menu className={solid ? 'text-forest' : 'text-white'} />}
        </button>
      </div>

      {/* Mobile menu */}
      {openMobile && (
        <div className="xl:hidden bg-cream border-t border-sand max-h-[80vh] overflow-y-auto">
          <div className="px-5 py-4 flex flex-col">
            {navItems.map((item) => (
              <div key={item.label} className="border-b border-sand/70">
                <div className="flex items-center justify-between">
                  <Link to={item.to} className="py-3 text-ink font-500">{item.label}</Link>
                  {item.children && (
                    <button className="p-2" onClick={() => setOpenDrop(openDrop === item.label ? null : item.label)}>
                      <ChevronDown className={`w-4 h-4 transition-transform ${openDrop === item.label ? 'rotate-180' : ''}`} />
                    </button>
                  )}
                </div>
                {item.children && openDrop === item.label && (
                  <div className="pb-2 pl-4">
                    {item.children.map((c) => (
                      <Link key={c.label} to={c.to} className="block py-2 text-sm text-forest-light">{c.label}</Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <Link to="/give" className="mt-4 text-center px-5 py-3 rounded-full bg-gold text-white font-600">Donate</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
